<template>
  <div>
    <Header>
      <MenuList :data="data.allMenus" :cta-data="data.allMenuCtas" />
      <MenuCta :data="data.allMenuCtas" class="absolute right-4 top-6 hidden w-fit lg:block" />
    </Header>
    <main>
      <slot />
    </main>
    <LazyFooter :data="data" />
    <CookieBanner />
  </div>
</template>

<script setup>
import locales from '~/i18n/locales'

const { locale } = useI18n()
const langAttr = computed(() => locales.find((l) => l.code === locale.value).code)

defineProps({
  data: {
    type: Object,
    default: () => {}
  }
})

useHead({
  htmlAttrs: {
    lang: langAttr
  }
})
</script>
